module.exports = __webpack_public_path__ + "img/attendance1.1b00154e.jpg";